import tags from "../../../../services/firebase/tags";

const config = ({item, channelList, valueForEmbedType}) => ({
  type: {
    elementType: 'radio',
    elementConfig: {

    },
    options: [
      {
        value: 'Surgeries',
        title: 'Surgery'
      },
      {
        value: 'Conferences',
        title: 'Conference'
      },
      {
        value: 'Webinars',
        title: 'Webinar'
      }
    ],
    value: item.type,
    validation: {
      required: true
    },
    valid: false,
    touched: false
  },
  title: {
    elementType: 'input',
    label: "Event Title",
    elementConfig: {
      type: 'text',
      placeholder: 'Title',
      required: 'required'
    },
    value: item.title,
    validation: {
      required: true
    },
    valid: false,
    touched: false
  },
  channel: {
    elementType: 'select',
    label: "Channel",
    elementConfig: {
      placeholder: 'Select a channel',
      required: "required"
    },
    options: channelList,
    value: item.channel || '',
    validation: {
      required: true
    },
    valid: false,
    touched: false
  },
  embedTypeRadioButtons: {
    elementType: 'radio',
    elementConfig: {

    },
    options: [
      {
        value: 'youtube',
        title: 'YouTube'
      },
      {
        value: 'ustream',
        title: 'Ustream'
      },
      {
        value: 'upload',
        title: 'Upload'
      }
    ],
    value: item.embedType || valueForEmbedType,
    validation: {
      required: true
    },
    valid: false,
    touched: false
  },
  embedLinkYouTube: {
    elementType: 'input',
    noShown: item.isUpcoming,
    label: "YouTube embed video url",
    embedYouTube: true,
    elementConfig: {
      type: 'text',
      placeholder: 'YouTube URL to video'
    },
    value: item.youTubeUrl,
    validation: {

    },
    valid: false,
    touched: false
  },
  embedLinkUstream: {
    elementType: 'input',
    noShown: item.isUpcoming,
    label: "Ustream embed video url",
    embedYouTube: true,
    elementConfig: {
      type: 'text',
      placeholder: 'Ustream URL to video'
    },
    value: item.videoEmbed && `https://www.ustream.tv/embed/recorded/${item.videoEmbed.id}`,
    validation: {

    },
    valid: false,
    touched: false
  },
  description: {
    elementType: 'textarea',
    label: "Event Description",
    elementConfig: {
      rows: 5
    },
    value: item.description,
    validation: {

    },
    valid: false,
    touched: false
  },
  restriction: {
    elementType: 'select',
    label: "Restriction",
    elementConfig: {
      placeholder: 'Select a channel',
      disabled: true,
      defaultValue: "Feature Coming Soon"
    },
    options: [
      {id: "free", title: "Free event (no subscription needed)"},
      {id: "lucy", title: "Lucy"},
      {id: "yiminghe", title: "Yiminghe"}
    ],
    value: "free",
    validation: {

    },
    valid: false,
    touched: false
  },
  tags: {
    elementType: 'tags',
    label: "Enter Tags",
    elementConfig: {
      mode: "tags",
      style: { width: "100%" },
      placeholder: 'Tags Mode'
    },
    options: tags,
    value: item.tags,
    validation: {

    },
    valid: false,
    touched: false
  }
});

export default config;


// WEBPACK FOOTER //
// ./src/pages/EventEditor/Content/EventForm/ControlsOptionsConfig.js